<template>
  <div class="flex">
    <div class="bg"></div>
    <div class="bg bg2"></div>
    <div class="bg bg3"></div>
    <article class="htmleaf-container">
      <header class="htmleaf-header">
        <h1>
          <!-- 账号密码：
                    <span>adminadmin</span>-->
        </h1>
        <div class="htmleaf-links"></div>
      </header>
      <div class="panel-lite">
        <div class="thumbur">
          <div class="icon-lock"></div>
        </div>
        <h4>登录</h4>
        <div class="form-group">
          <input required="required" @keyup.enter="r_go_home()" class="form-control" v-model="user" />
          <label class="form-label">用户名</label>
        </div>
        <div class="form-group">
          <input type="password" required="required" class="form-control" v-model="password"
            @keyup.enter="r_go_home()" />
          <label class="form-label">密 码</label>
        </div>
        <a href="#" @click="forget">忘记密码 ?</a>
        <button class="floating-btn" @click="r_go_home()">
          <i class="icon-arrow"></i>
        </button>
      </div>
    </article>
  </div>
</template>

<script>
import { login } from "@/utils/api/index";
export default {
  name: "HelloWorld",
  data() {
    return {
      user: "",
      password: "",
    };
  },
  created() {
    // if (window.localStorage.token == "") {
    //     window.localStorage.if_login = true;
    // }
    if (this.$route.query.login) {
      window.localStorage.token = "";
      this.$message.error("登录过期！");
      // this.$router.push("/");
    }
  },
  destroyed() {
    // window.localStorage.if_login = "";
  },
  methods: {
    r_go_home() {
      if (this.user == "") {
        this.$message.error("请输入用户名！");
        return false;
      }
      if (this.password == "") {
        this.$message.error("请输入密码！");
        return false;
      }
      if (this.user != "" && this.password != "") {
        let data = {
          name: this.user,
          password: this.password,
          // loading:231
        };
        login(data).then((res) => {
          if (res.code == -1) {
            this.$message.error(res.msg);
          } else if (res.code == 1) {
            // this.$message({
            //     message: "登录成功",
            //     type: "success"
            // });
            console.log("登录成功信息", res.data);
            this.$message.success("登录成功！");
            window.localStorage.token = res.data.token;
            window.localStorage.role_id = res.data.role_id;
            window.localStorage.app_look_fields = JSON.stringify(
              res.data.role_info.app_look_fields
            );
            window.localStorage.web_look_fields = JSON.stringify(
              res.data.role_info.web_look_fields
            );

            setTimeout(() => {
              // this.$router.push("/home");
              this.$router.go(0);
            }, 300);
          }
        });
      }
    },
    forget() {
      this.$message("请联系管理员！");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang='scss'>
@import "./login.scss";
</style>


// WEBPACK FOOTER //
// src/view/login/login.vue